var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1912 0H3.80248C1.70243 0 0 1.70243 0 3.80248V20.1975C0 22.2976 1.70243 24 3.80248 24H20.1912C22.2912 24 23.9937 22.2976 23.9937 20.1975V3.80248C23.9937 1.70243 22.2912 0 20.1912 0Z",
    fill: "#1E72B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.289 6V12.1433C17.289 12.3072 17.1602 12.4359 16.9964 12.4359H7.64098L10.0398 9.80887L8.74093 8.62701L5.44692 12.237C4.85599 12.8279 4.85599 13.7991 5.41767 14.3608L8.74093 18L10.0398 16.8181L7.64098 14.1911H16.9964C18.1256 14.1911 19.0442 13.2726 19.0442 12.1433V6H17.289Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.289 6V12.1433C17.289 12.3072 17.1602 12.4359 16.9964 12.4359H7.64098L10.0398 9.80887L8.74093 8.62701L5.44692 12.237C4.85599 12.8279 4.85599 13.7991 5.41767 14.3608L8.74093 18L10.0398 16.8181L7.64098 14.1911H16.9964C18.1256 14.1911 19.0442 13.2726 19.0442 12.1433V6H17.289Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.289 6V12.1433C17.289 12.3072 17.1602 12.4359 16.9964 12.4359H7.64098L10.0398 9.80887L8.74093 8.62701L5.44692 12.237C4.85599 12.8279 4.85599 13.7991 5.41767 14.3608L8.74093 18L10.0398 16.8181L7.64098 14.1911H16.9964C18.1256 14.1911 19.0442 13.2726 19.0442 12.1433V6H17.289Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.289 6V12.1433C17.289 12.3072 17.1602 12.4359 16.9964 12.4359H7.64098L10.0398 9.80887L8.74093 8.62701L5.44692 12.237C4.85599 12.8279 4.85599 13.7991 5.41767 14.3608L8.74093 18L10.0398 16.8181L7.64098 14.1911H16.9964C18.1256 14.1911 19.0442 13.2726 19.0442 12.1433V6H17.289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.7a4b5d82b5e0715ee38568ca74061690.svg";
export { ForwardRef as ReactComponent };